"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
exports.validationSchema = (0, yup_1.object)().shape({
    contractId: mui_inputs_asset_1.tokenAssetContractIdValidationSchema,
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    deposit: mui_inputs_asset_1.templateAssetValidationSchema,
    reward: mui_inputs_asset_1.templateAssetValidationSchema,
    durationAmount: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(1, "form.validations.rangeUnderflow"),
    penalty: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow")
        .max(10000, "form.validations.rangeUnderflow"),
    maxCycles: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map